export const APP_CERTIFICATIONS = ["netflix"];
export function isAppCertification(v) {
    return (typeof v === "string" &&
        APP_CERTIFICATIONS.includes(v));
}
export const SEEDED_CERTIFICATIONS = {
    Netflix: "netflix",
};
export const CERTIFICATION_LABEL = {
    netflix: "Netflix",
};
export function certificationOf(entry) {
    const cert = entry.certification;
    return isAppCertification(cert) ? cert : null;
}
export const CERTIFIED_TILE_ASPECT = 16 / 9;
export const CERTIFIED_TILE_ASPECT_TOLERANCE = 0.02;
export function isConformantTileAspect(width, height) {
    if (!(width > 0) || !(height > 0))
        return false;
    return (Math.abs(width / height - CERTIFIED_TILE_ASPECT) <=
        CERTIFIED_TILE_ASPECT_TOLERANCE * CERTIFIED_TILE_ASPECT);
}
export const CERTIFIED_LOGO_MAX_WIDTH = "72%";
export const CERTIFIED_LOGO_MAX_HEIGHT = "60%";
export function certificationReason(cert) {
    return `${CERTIFICATION_LABEL[cert]} requires first place while it is on`;
}
